<template>
    <div v-if="display">
    <div class="notification is-danger-light">
        <button class="delete" @click="display = !display"></button>
        <h5 class="subtitle is-5">{{title}}</h5>
        <div>
            <ul v-for="error in this.errors">
                <li>{{error.detail}}</li>
            </ul>
        </div>
    </div>
    </div>
</template>

<script>
    export default {
        name: "ErrorDisplay",
        props: {
            errors: {
                type: Array,
                default: []
            },
            title: {
                type: String,
                default: "Something went wrong."
            }
        },
        data() {
            return {
                display: true,
            }
        }
    }
</script>

<style scoped>
    .is-danger-light {
        border-color: #f14668;
        color: #cc0f35;
        background-color: #feecf0;
    }
    .notification {
        margin-bottom: 25px;
    }
</style>